import 'owl.carousel';

class InsurersCarousel {
    constructor() {
        const $carousel = $('.js-insurers-carousel');
        if (!$carousel.length) return;

        this.initCarousel($carousel);
    }

    initCarousel($carousel) {
        $carousel.owlCarousel({
            animateOut: 'fadeOut',
            responsive: {
                0: {
                    autoplay: true,
                    autoplayHoverPause: true,
                    autoplaySpeed: 12000,
                    autoplayTimeout: 0,
                    autoWidth: true,
                    loop: true,
                },
                700: {
                    autoplay: true,
                    autoplayHoverPause: true,
                    autoplayTimeout: 6000,
                    center: true,
                    items: 1,
                    loop: true,
                    lazyLoad: true,
                },
            },
        });
    }
}

export default new InsurersCarousel();
